<template>
    <vx-button @click.prevent="emit('click')" data-test="ai-cost-optimization" color="transparent" type="button">
        <span class="flex items-center gap-1">
            <font-awesome-icon widthAuto :icon="faWandMagicSparkles" class="text-sm"></font-awesome-icon>
            <span>Cost-Optimized</span>
            <experimental-pill class="pointer-events-none" placement="right"></experimental-pill>
        </span>
    </vx-button>
</template>

<script lang="ts" setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faWandMagicSparkles } from '@fortawesome/pro-regular-svg-icons';
import ExperimentalPill from '~/components/general/ExperimentalPill.vue';

const emit = defineEmits<{
    click: [];
}>();
</script>
